import script from "./BrushMapSelected.vue?vue&type=script&lang=ts&setup=true"
export * from "./BrushMapSelected.vue?vue&type=script&lang=ts&setup=true"

import "./BrushMapSelected.vue?vue&type=style&index=0&id=60488381&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60488381"]])

export default __exports__